import React, { useState } from "react"
import { withStyles } from "@material-ui/core/styles"
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel"
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary"
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails"
import styled from "styled-components"
import FAQSchema from "./FAQSchema";

const ExpansionPanel = withStyles({
    root: {
        // paddingLeft: 20,
        // paddingRight: 20,
        boxShadow: "none",
        backgroundColor: "transparent",
        margin: "0 auto",
        minWidth: "auto",
        width: "100%",
        "&$expanded": {
            margin: "auto"
        },
        "@media screen and (min-width: 900px)": {
            width: "80%",
            minWidth: "800px",
        },
    },
    expanded: {
        margin: "auto",
    },
})(MuiExpansionPanel)

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: `0 16px 16px`,
        "@media screen and (min-width: 760px)": {
            // margin: `0 var(--space-xl)`,
        },
    },
}))(MuiExpansionPanelDetails)

const ExpandMoreIcon = () => (
    <svg
        width="20"
        height="12"
        viewBox="0 0 12 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11 1L6 6L1 1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const FAQSection = styled.section`
    padding: 5rem 0 6rem;
    .faq-expansion-pannel-wrapper {
        .MuiExpansionPanelSummary-expandIcon {
            margin-right: 6px;
        }
    }
    .faq-question-title {
        padding-left: 14px;
        margin-bottom: 2px;
    }
`

export default ({ data }) => {
    const { faqs_rc, title_rc } = data.faq_rc
    const [panelActive, setPanelActive] = useState("")
    const ExpansionPanelSummary = withStyles({
        root: {
            minHeight: 60,
            paddingLeft: "0",
            paddingRight: "0",
            transition: `all .3s var(--cubic-bezier)`,
            "&$expanded": {
                minHeight: 60,
            },
            "@media screen and (min-width: 760px)": {
                minHeight: "60px",
            },
        },
        expanded: {
            marginBottom: "0 !important",
            marginTop: "0 !important",
            "@media screen and (max-width: 600px)": {
                // paddingTop: "6px !important",
                marginBottom: "4px !important",
                marginTop: "5px !important",
            },
        },
    })(MuiExpansionPanelSummary)

    return (
        <>
            <FAQSchema faqs={faqs_rc}/>
            <FAQSection
                id="faq-section"
            >
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <h2 className="display-4">{title_rc}</h2>
                            <div
                                className="bg-orange mx-auto my-5"
                                style={{ width: 140, height: 4 }}
                            ></div>
                        </div>
                    </div>
                </div>
                <div style={{
                    opacity: 0,
                    animation:
                        "fadeUpSubtle 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                }}>
                    {faqs_rc.map((faq, index) => {
                        return (
                            <div className="bg-orange-lightest border-b-4 border-solid border-white">
                                <div className="container max-w-2xl">
                                    <div className="container__row  py-sm">
                                        <div
                                            
                                        >
                                            <ExpansionPanel
                                                expanded={
                                                    panelActive === `panel-${index}`
                                                }
                                                key={index}
                                            >
                                                <ExpansionPanelSummary
                                                    className="faq-expansion-pannel-wrapper"
                                                    expandIcon={<ExpandMoreIcon />}
                                                    onClick={() => {
                                                        if (
                                                            panelActive ===
                                                            `panel-${index}`
                                                        ) {
                                                            setPanelActive("")
                                                        } else {
                                                            setPanelActive(
                                                                `panel-${index}`
                                                            )
                                                        }
                                                    }}
                                                >
                                                    <h3 className="pr-md-4 h5 faq-question-title text-orange-text">
                                                        {faq.faq_question_rc}
                                                    </h3>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails>
                                                    <div>
                                                        <div
                                                            className="font-weight-normal text-orange-text"
                                                            dangerouslySetInnerHTML={{
                                                                __html: faq.faq_answer_rc,
                                                            }}
                                                        />
                                                    </div>
                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })} 
                </div>
            </FAQSection>
        </>
    )
}
